import React, { useLayoutEffect, useRef } from "react";
import { ChatMessageCard } from "../ChatMessageCard/ChatMessageCard";
import { IMainChatProps, IChatMessageCardProps } from "../Types/Type";
import { Spin } from "antd";
import { useAppDispatch } from "../../../store/reduxHooks";

import classes from "./MainChat.module.css";

// список сообщений в чате
export function MainChat(props: IMainChatProps) {
  const { chat, spinData } = props;
  const wrapperRef = useRef<HTMLDivElement>(null);
  const dispatch = useAppDispatch();

  useLayoutEffect(() => {
    const wrapperElement = wrapperRef.current;
    if (wrapperElement) {
      wrapperElement.scrollTop = wrapperElement.scrollHeight;
    }
  }, [dispatch, chat, spinData]);

  return (
    <Spin spinning={spinData} size="large">
      <div ref={wrapperRef} className={classes.mainChat}>
        {chat?.map((messaage: IChatMessageCardProps) => {
          const keyId: string = String(messaage.id);
          return <ChatMessageCard key={keyId} {...messaage} />;
        })}
      </div>
    </Spin>
  );
}
